<template>
  <el-container
    id="container-product-editor"
    class="is-vertical"
    style="height: 100%; width: 100%; position: fixed;"
  >
    <top-header>
      <template slot="left">
        <div
          style="width: max-content; height:100%; display: inline-flex; align-items: center; justify-content: center;top: 0;position: absolute;"
        >
          <el-breadcrumb separator-class="el-icon-arrow-right" class="white">
            <el-breadcrumb-item v-show="!isTeamBuyingProduct" :to="{ path: '/product', query: backListQueryParams }">商品列表 P{{$route.query.frompage || 1}}</el-breadcrumb-item>
            <el-breadcrumb-item v-show="isTeamBuyingProduct" :to="{ name: 'teamBuying-product-list', params:{teamBuyingID: $route.params.teamBuyingID}, query:{page:$route.query.frompage || 1, keyword:$route.query.keyword} }">團購商品列表 P{{$route.query.frompage || 1}}</el-breadcrumb-item>
            <el-breadcrumb-item>{{title}}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </template>
    </top-header>
    <el-container>
      <left-menu />

      <el-main v-loading="isLoading" :element-loading-text="loadingHint">
        <!-- <form-content :form="form" style="margin-top: 80px;" /> -->

        <el-form label-width="80px" @submit.native.prevent  style="margin-top: 40px;">

          <el-tabs v-if="!isTeamBuyingProduct" value="common" type="card">
            <el-tab-pane label="通用" name="common">

              <el-form-item label="商品類型" class="text-left">
                <el-select v-model="form.ProductType" placeholder="選擇類型" @change="onProductTypeChanged">
                  <el-option label="一般商品" :value="0"/>
                  <el-option label="加價購" :value="1"/>
                </el-select>
              </el-form-item>

              <el-form-item label="排序">
                <el-input v-model="form.SortOrder" type="number" step="1" min="0"></el-input>
              </el-form-item>

              <el-form-item :label="form.ProductType == 0 ? '原價格' : '價格'" class="text-left">
                <el-input style="width: 150px;" v-model="form.Tw.OriginalPrice">
                  <template slot="prepend">NT$</template>
                </el-input>
                <label class="el-form-item__label" style="width: 160px; float:unset; margin-left: 30px;">單位</label>
                <el-input style="width: 150px;" v-model="form.Tw.UnitTitle">
                </el-input>

                <!--特價-->
                <label v-show="!isTeamBuyingProduct && form.ProductType != 1" class="el-form-item__label" style="width: 160px; float:unset; margin-left: 30px;">特價</label>
                <el-input v-show="!isTeamBuyingProduct && form.ProductType != 1" style="width: 150px;" v-model="form.Tw.Discount.Price">
                  <template slot="prepend">NT$</template>
                </el-input>
                <div v-show="form.Tw.Discount.Price > 0" class="discount-wrapper">
                  <label class="el-form-item__label" style="width: 120px; float:unset; margin-left: 30px;">促銷日期</label>
                  <el-date-picker v-model="form.Tw.Discount.BeginAt" type="date" placeholder="選擇日期" style="width: 160px"></el-date-picker>
                  <label class="el-form-item__label" style="width: 120px; float:unset; margin-left: 30px;">結束日期</label>
                  <el-date-picker v-model="form.Tw.Discount.EndAt" type="date" placeholder="選擇日期" style="width: 160px"></el-date-picker>

                  <label class="el-form-item__label" style="width: 160px; float:unset; margin-left: 30px;">特價說明</label>

                  <el-upload
                    v-loading="isProcessingDiscountImage"
                    ref="el-upload-discount"
                    accept="image/svg+xml"
                    class="el-upload-discount"
                    drag
                    action
                    :auto-upload="true"
                    :http-request="e => processImageFile(e, genDiscountImageFileParam())">
                    <img
                      ref="discountImg"
                      v-show="form.Tw.Discount['discountImageObjectURL'] || form.Tw.Discount.ImageURL"
                      @load="e => onImageLoaded(e, genDiscountImageFileParam())"
                      class="preview"
                      :src="form.Tw.Discount['discountImageObjectURL'] || form.Tw.Discount.ImageURL"
                      style="max-width: 100%;max-height: 120px;"/>
                    <!-- <i v-show="!(form.Tw.CoverImageURLX1 || form.Tw['coverObjectURL'])" class="el-icon-upload"></i> -->
                    <div class="el-upload__text">
                      90*90 svg
                    </div>
                  </el-upload>

                </div>
                <p v-show="!isTeamBuyingProduct && form.ProductType != 1" class="hint">設定的結束日期，當天仍會特價，過夜後結束。<br>舉例來說，若設定12/31結束，則跨年倒數時(12/31 23:59:59)都還會特價，1/1 00:00才會恢復原價</p>
                <p v-show="!isTeamBuyingProduct && form.ProductType != 1" class="hint">特價說明svg圖片檔案請使用Chrome瀏覽器上傳</p>
              </el-form-item>

              <el-form-item label="加價購" v-show="form.ProductType == 1" class="text-left">
                <el-upload
                  v-loading="isProcessingAdditionalImage"
                  ref="el-upload-additional"
                  accept="image/svg+xml"
                  class="el-upload-discount"
                  drag
                  action
                  :auto-upload="true"
                  :http-request="e => processImageFile(e, genAdditionalImageFileParam())">
                  <img
                    ref="additionalImage"
                    v-show="form.Tw.additionalImageObjectURL || form.Tw.AdditionalImageURL"
                    @load="e => onImageLoaded(e, genAdditionalImageFileParam())"
                    class="preview"
                    :src="form.Tw.additionalImageObjectURL || form.Tw.AdditionalImageURL"
                    style="max-width: 100%;max-height: 120px;"/>
                  <!-- <i v-show="!(form.Tw.CoverImageURLX1 || form.Tw['coverObjectURL'])" class="el-icon-upload"></i> -->
                  <div class="el-upload__text">
                    90*90 svg
                  </div>
                </el-upload>
              </el-form-item>

              <el-form-item label="稅率" class="text-left">
                <el-select v-model="form.Tw.TaxType" placeholder="選擇稅率">
                  <el-option label="應稅" :value="1"/>
                  <el-option label="免稅" :value="3"/>
                </el-select>
              </el-form-item>

              <el-form-item label="上架日期">
                <el-date-picker v-model="form['Tw'].ReleaseAt" class="left" type="date" placeholder="選擇日期"></el-date-picker>
                <label class="el-form-item__label" style="width: 160px;">下架日期</label>
                <el-date-picker v-model="form['Tw'].CloseAt" class="left" type="date" placeholder="選擇日期"></el-date-picker>
                <p class="hint">設定的下架日期，當天仍會在架上，過夜後下架。<br>舉例來說，若設定12/31下架，則跨年倒數時(12/31 23:59:59)都還會在架上，1/1 00:00才會下架</p>
              </el-form-item>

              <el-form-item label="預購商品" class="text-left">
                <el-switch
                  v-model="form['Tw'].IsPreOrderProduct"
                  active-text="是"
                  inactive-text="否"
                  inactive-color="red"
                ></el-switch>
              </el-form-item>

              <el-form-item label="限制地區" class="text-left">
                <el-switch
                  v-model="form['Tw'].IsRestrictedArea"
                  active-text="是"
                  inactive-text="否"
                  inactive-color="red"
                ></el-switch>
              </el-form-item>

            </el-tab-pane>
          </el-tabs>
          <div v-else>
            <el-form-item label="價格" class="text-left">
              <el-input style="width: 150px;" v-model="form.Tw.OriginalPrice">
                <template slot="prepend">NT$</template>
              </el-input>
              <label class="el-form-item__label" style="width: 160px; float:unset; margin-left: 30px;">單位</label>
              <el-input style="width: 150px;" v-model="form.Tw.UnitTitle">
              </el-input>

            </el-form-item>

            <el-form-item label="稅率" class="text-left">
              <el-select v-model="form.Tw.TaxType" placeholder="選擇稅率">
                <el-option label="應稅" :value="1"/>
                <el-option label="免稅" :value="3"/>
              </el-select>
            </el-form-item>
          </div>

          <el-tabs v-if="!isTeamBuyingProduct" v-model="activeLang" type="card">
            <el-tab-pane label="繁中" name="tw">
              <form-content :form="form" form-key="Tw"
                @title-changed="onTitleChanged"/>
            </el-tab-pane>
            <el-tab-pane v-if="languages.includes('Cn')" label="簡中" name="cn">
              <form-content :form="form" form-key="Cn"/>
            </el-tab-pane>
            <el-tab-pane v-if="languages.includes('En')" label="英文" name="en">
              <form-content :form="form" form-key="En"/>
            </el-tab-pane>
            <el-tab-pane v-if="languages.includes('Jp')" label="日文" name="jp">
              <form-content :form="form" form-key="Jp"/>
            </el-tab-pane>
          </el-tabs>
          <form-content v-else :form="form" form-key="Tw"
            @title-changed="onTitleChanged"/>
        </el-form>

        <p class="auto-save-hint">{{autoSaveHint}}</p>
        <p class="url-hint">https://www.syunkaya.com.tw/product/{{form.URLKey}}</p>

        <el-switch
          v-model="form.Tw.IsActive"
          class="switch-deploy"
          active-text="上架"
          inactive-text="下架"
          inactive-color="red"
        ></el-switch>

        <el-tooltip v-if="!isEdit" class="item" effect="dark" placement="top-start">
          <div slot="content">商品網址路徑為以下: https://www.syunkaya.com.tw/product/{{form.URLKey}}</div>
          <el-button type="primary" class="btn-set-url" size="mini" @click="showURLEditor">設定網址</el-button>
        </el-tooltip>

        <el-tooltip v-if="!isTeamBuyingProduct" class="item" effect="dark" placement="top-start">
          <div slot="content">一鍵翻譯會自動將繁體中文的內容翻譯成其他語言，<br>並且覆蓋資料!<br><br>包含圖片影片也會覆蓋，包含內容編輯器</div>
          <el-button type="primary" class="btn-translate" size="mini" @click="autoTranslate">一鍵翻譯</el-button>
        </el-tooltip>

        <el-button type="primary" class="btn-upload" size="mini" @click="submit">
          送出
          <i class="el-icon-upload el-icon--right"></i>
        </el-button>
      </el-main>

      <u-r-l-setting-modal :isShow="isShowUrlSetModal" @close="isShowUrlSetModal = false" :url-key="form.URLKey" @submit="onSetURLKey"/>
    </el-container>
  </el-container>
</template>

<script>
import moment from 'moment'
import LeftMenu from '@/views/components/LeftMenu.vue'
import TopHeader from '@/views/components/TopHeader.vue'
import FormContent from '@/data/product/view/editor-form.vue'
import MixinOfPreventLeaveEditPage from '@/utils/mixin-prevent-leave.vue'
import MixinLanguages from '@/utils/mixin-languages.vue'
import URLSettingModal from '@/data/product/view/url-setting-modal.vue'
import MixinOfTranslation from '@/utils/mixin-translate.vue'
import MixinAutoSave from '@/utils/mixin-autosave.vue' // cacheKey required
import MixinProcessImageFile from '@/utils/mixin-process-image-file.vue'
export default {
  mixins: [MixinOfPreventLeaveEditPage, MixinLanguages, MixinOfTranslation, MixinAutoSave, MixinProcessImageFile],
  components: {
    LeftMenu,
    TopHeader,
    FormContent,
    URLSettingModal
  },
  data () {
    return {
      oriObj: {},
      form: {
        ProductType: 0,
        Tw: { Tags: [], IsActive: true, Date: moment().format(), ReleaseAt: moment().startOf('day').format(), Discount: { BeginAt: moment().startOf('day').format() }, TaxType: 3 },
        Cn: { Tags: [], IsActive: true, Date: moment().format(), ReleaseAt: moment().startOf('day').format(), Discount: { BeginAt: moment().startOf('day').format() }, TaxType: 3 },
        En: { Tags: [], IsActive: true, Date: moment().format(), ReleaseAt: moment().startOf('day').format(), Discount: { BeginAt: moment().startOf('day').format() }, TaxType: 3 },
        Jp: { Tags: [], IsActive: true, Date: moment().format(), ReleaseAt: moment().startOf('day').format(), Discount: { BeginAt: moment().startOf('day').format() }, TaxType: 3 }
      },
      activeLang: 'tw',
      isLoading: false,
      loadingHint: '',
      // url key
      isShowUrlSetModal: false,
      isURLKeySetManually: false,

      // discount image
      isProcessingDiscountImage: false,
      // 加價購圖示
      isProcessingAdditionalImage: false
    }
  },
  computed: {
    isEdit () {
      return this.$route.name !== 'createProduct' && this.$route.name !== 'createTeamBuyingProduct'
    },
    title () {
      return this.isEdit ? this.form.Tw.Name : '新增'
    },
    teamBuying () {
      return this.$store.state.teamBuying.list.find(o => o.ID == this.$route.params.teamBuyingID)
    },
    isTeamBuyingProduct () {
      return this.$route.name == 'createTeamBuyingProduct' || this.$route.name == 'updateTeamBuyingProduct'
    },
    backListQueryParams () {
      return {
        page: this.$route.query.frompage || 1, 
        keyword: this.$route.query.keyword, 
        filteringProductType: this.$route.query.filteringProductType, 
        filteringStatus: this.$route.query.filteringStatus
      }
    }
  },
  methods: {
    onProductTypeChanged() {
      if(this.form.ProductType==1) {
        for (let lang of this.languages) {
          if (!this.form[lang]) continue // for 團購商品 沒有其他語言
          this.form[lang].CategoryIDs = [62]
        }
      }
    },
    /* url key 設置 */
    onTitleChanged () {
      if (this.isEdit) return
      if (!this.isURLKeySetManually) {
        this.form.URLKey = this.form.Tw.Name.replace(/\//g, '')
      }
    },
    onSetURLKey (urlKey) {
      this.isURLKeySetManually = true
      this.form.URLKey = urlKey
    },
    showURLEditor () {
      this.isShowUrlSetModal = true
    },
    /* end url key */
    submit () {
      if (!this.validateInput()) {
        return
      }
      if (this.isImageUploading()) {
        return alert('圖片上傳中，請稍後再送出')
      }

      var payload = JSON.parse(JSON.stringify(this.form))

      // 通用欄位
      for (let lang of this.languages) {
        if (!payload[lang]) continue // for 團購商品 沒有其他語言
        payload[lang].IsActive = payload.Tw.IsActive
        payload[lang].TaxType = payload.Tw.TaxType
        payload[lang].IsPreOrderProduct = payload.Tw.IsPreOrderProduct
        payload[lang].IsRestrictedArea = payload.Tw.IsRestrictedArea
        payload[lang].CloseAt = payload.Tw.CloseAt
        payload[lang].ReleaseAt = payload.Tw.ReleaseAt
      }
      // 2021/12/09 價格與特價自動同步，以繁體中文為主
      for (let key of this.languages) {
        if (!payload[key]) continue // for 團購商品 沒有其他語言
        payload[key].OriginalPrice = parseInt(payload['Tw'].OriginalPrice)
        // payload[key].Discount = payload['Tw'].Discount
      }
      // 2022/02/21 特價同步異常，不能直接同步，要同步資料
      for (let key of this.languages) {
        if (!payload[key]) continue // for 團購商品 沒有其他語言
        if (!payload['Tw'].Discount) {
          payload[key].Discount = null
        } else {
          if (!payload[key].Discount && payload['Tw'].Discount) {
            payload[key].Discount = {}
          }
          for (let k in payload['Tw'].Discount) {
            if (k === 'ID') continue
            payload[key].Discount[k] = payload['Tw'].Discount[k]
          }
        }
      }

      payload.SortOrder = parseInt(payload.SortOrder)

      // payload.OriginInfos = this.$store.state.originInfo.list.filter(o => payload.OriginInfoIDs.includes(o.ID))

      for (let key of this.languages) {
        if (!payload[key]) continue // for 團購商品 沒有其他語言
        payload[key].Tags = this.$store.state.productTag.list.filter(o => (payload[key].TagIDs || []).includes(o.ID))
        payload[key].Categories = this.$store.state.productCategory.list.filter(o => (payload[key].CategoryIDs || []).includes(o.ID))

        payload[key].Contents = JSON.stringify(payload[key].contentJsonArr)
        payload[key].contentJsonArr = undefined

        payload[key].Images = JSON.stringify(payload[key].imagesJsonArr)
        if (payload[key].Images === '') payload[key].Images = '[]'
        payload[key].imagesJsonArr = undefined

        payload[key].OriginalPrice = parseInt(payload[key].OriginalPrice)

        if (payload[key].Discount) {
          payload[key].Discount.Price = parseInt(payload[key].Discount.Price)
          if (!payload[key].Discount.Price) {
            payload[key].Discount = null
          }
        }
        payload[key].IsActive = !!payload['Tw'].IsActive
      }

      if (this.isTeamBuyingProduct) {
        if (!this.teamBuying) {
          return alert('團購資料異常')
        }
        payload.TeamBuyingID = this.teamBuying.ID
      }
      this.isLoading = true

      this.loadingHint = '正在上傳資料'

      let promise = this.isEdit
        ? this.$services.product.edit(this, payload)
        : this.$services.product.add(this, payload)
      promise
        .then(res => {
          let ok = res && res.data && res.data.status === 'ok'
          if (ok) this.onObjAddedit(res)
        })
        .catch(this.$handleServiceError)
        .finally(() => {
          this.isLoading = false
        })
    },
    isImageUploading () {
      for (let lang of this.languages) {
        if (!this.form[lang]) continue // for 團購商品 沒有其他語言
        // 封面圖片
        if (this.form[lang]['coverImageBlob@3x'] && this.form[lang]['coverImageBlob@3x'] instanceof Blob) return true
        if (this.form[lang]['coverImageBlob@2x'] && this.form[lang]['coverImageBlob@2x'] instanceof Blob) return true
        if (this.form[lang]['coverImageBlob@1x'] && this.form[lang]['coverImageBlob@1x'] instanceof Blob) return true

        // 圖片編輯器
        for (let i in this.form[lang].contentJsonArr) {
          let obj = this.form[lang].contentJsonArr[i]
          if (!obj) continue
          if (obj.type === 'image' && obj.value.img instanceof Blob) {
            return true
          }
        }
      }
      return false
    },
    onObjAddedit (res) {
      this.clearCache()
      this.isSubmitted = true
      this.loadResult(res)
      this.$message({
        message: `${this.isEdit ? '修改' : '新增'}成功`,
        type: 'success'
      })
      this.form = {}
      this.backList()
    },
    loadResult (res) {
      var newObj = res.data.result
      if (!this.isEdit) {
        this.$store.state.product.list.splice(0, 0, newObj)
      } else {
        newObj = Object.assign(this.oriObj, newObj)
        let idx = this.$store.state.product.list.findIndex(
          o => o.ID === newObj.ID
        )
        if (idx >= 0) {
          this.$set(this.$store.state.product.list, idx, newObj)
          this.oriObj = newObj
        } else {
          console.error(`unknown product for id ${newObj.ID}`)
        }
      }
    },
    backList () {
      if (this.isTeamBuyingProduct) {
        return this.$router.push({ name: 'teamBuying-product-list',
          params: { teamBuyingID: this.$route.params.teamBuyingID },
          query: this.backListQueryParams })
      }
      this.$router.push({ name: 'product-list',
        query: this.backListQueryParams })
    },
    validateInput () {
      var errMsg = null
      if (!this.form.Tw.Name) {
        errMsg = '請輸入名稱'
      }
      if (!this.form.Tw.UnitTitle) {
        errMsg = '商品單位是必填，否則綠界開立電子發票會出現異常'
      }

      /* 2021/12/09 自動同步
      // 價格
      var OriginalPrice = this.form.Tw.OriginalPrice
      var isOriginalPriceDifferent = false
      for (let key of this.languages) {
        if (this.form[key].OriginalPrice != OriginalPrice) isOriginalPriceDifferent = true
      }
      if (isOriginalPriceDifferent) {
        errMsg = '價格設置異常，不同語系間必須設置一樣的價格'
      }
      // 特價
      var DiscountPriceTw = parseInt(this.form.Tw.Discount && this.form.Tw.Discount.Price)
      var isDiscountPriceDifferent = false
      for (let key of this.languages) {
        let discountPriceOfTheLang = parseInt((this.form[key].Discount && this.form[key].Discount.Price))
        if (isNaN(discountPriceOfTheLang) && isNaN(DiscountPriceTw)) continue
        if (discountPriceOfTheLang != DiscountPriceTw) isDiscountPriceDifferent = true
      }
      if (isDiscountPriceDifferent) {
        errMsg = '折扣設置異常，不同語系間必須設置一樣的特價價格'
      }
      */

      if (errMsg) {
        this.$alert(errMsg, '錯誤', {
          confirmButtonText: '確認',
          type: 'error'
        })
        return false
      }

      if (errMsg) {
        this.$alert(errMsg, '錯誤', {
          confirmButtonText: '確認',
          type: 'error'
        })
      }
      return errMsg === null
    },
    // tranlsate
    autoTranslate () {
      this.isLoading = true

      const translateKeys = ['Name', 'Description', 'UnitTitle']
      const syncKeys = ['TagIDs', 'CategoryIDs', 'Date', 'OriginalPrice', 'DiscountPrice', 'DiscountBeginAt', 'DiscountEndAt', 'DiscountImageURL', 'ReleaseAt', 'CloseAt', 'IsPreOrderProduct', 'IsRestrictedArea', 'Images']
      const contentJsonArr = this.form.Tw.contentJsonArr

      this.syncForm(syncKeys)

      // 每一次結束都先設定 isLoading=true，避免其中一個先完成而取消 loading
      let promises1 = this.translateForm(translateKeys).then(() => { this.isLoading = true })
      let promises2 = this.translateContentEditor(contentJsonArr).then(() => { this.isLoading = true })

      // 同步 images
      let langs = this.languages.filter(o => o !== 'Tw')
      let arrClone = this.form['Tw']['imagesJsonArr'] ? JSON.parse(JSON.stringify(this.form['Tw']['imagesJsonArr'])) : []
      for (let lang of langs) {
        this.$set(this.form[lang], 'imagesJsonArr', arrClone)
      }

      Promise.all([promises1, promises2]).then(() => {
        this.isLoading = false
      })
    },
    // discount image
    genDiscountImageFileParam () {
      let requiredSize = { w: 90, h: 90 }
      // 當我們上傳圖片後，
      let params = {
        'isProcessingImageKey': 'isProcessingDiscountImage',
        // 要求使用者應該要使用的尺寸
        'requiredSize': requiredSize,
        // element-ui el-upload，用於清除檔案
        'elUploadRefKey': 'el-upload-discount',
        // 上傳該圖片後，要顯示該圖片，並在onLoad時抓取該圖片尺寸
        'imgRefKey': 'discountImg',
        // 要上傳的表單 form
        'formObject': this.form['Tw'].Discount,
        // 呼應 imgRefKey，圖片壓縮後，createObjectURL，並顯示該圖片，並暫存紀錄該URL
        'blobObjectURLKey': 'discountImageObjectURL',
        // 每一張圖片在要上傳時 form 的欄位
        'imageURLFormKeys': [
          'ImageURL'
        ],
        // 每一張圖片要壓縮的比例
        'compressOptions': [
          {
            maxWidth: requiredSize.w,
            maxHeight: requiredSize.h
          }
        ],
        // 每一張圖片暫存的blob，確認沒問題後才會上傳
        'blobObjKeys': [
          'discountImageBlob'
        ],
        // 每一張圖片上傳的路徑
        'uploadPathPrefixList': [
          this.isEdit
            ? `product/${this.form.ID}/discount-`
            : `product/discount-${this.form['Tw'].Name}-`
        ]
      }
      return params
    },
    // additional image
    genAdditionalImageFileParam () {
      let requiredSize = { w: 90, h: 90 }
      // 當我們上傳圖片後，
      let params = {
        'isProcessingImageKey': 'isProcessingAdditionalImage',
        // 要求使用者應該要使用的尺寸
        'requiredSize': requiredSize,
        // element-ui el-upload，用於清除檔案
        'elUploadRefKey': 'el-upload-additional',
        // 上傳該圖片後，要顯示該圖片，並在onLoad時抓取該圖片尺寸
        'imgRefKey': 'additionalImage',
        // 要上傳的表單 form
        'formObject': this.form['Tw'],
        // 呼應 imgRefKey，圖片壓縮後，createObjectURL，並顯示該圖片，並暫存紀錄該URL
        'blobObjectURLKey': 'additionalImageObjectURL',
        // 每一張圖片在要上傳時 form 的欄位
        'imageURLFormKeys': [
          'AdditionalImageURL'
        ],
        // 每一張圖片要壓縮的比例
        'compressOptions': [
          {
            maxWidth: requiredSize.w,
            maxHeight: requiredSize.h
          }
        ],
        // 每一張圖片暫存的blob，確認沒問題後才會上傳
        'blobObjKeys': [
          'additionalImageBlob'
        ],
        // 每一張圖片上傳的路徑
        'uploadPathPrefixList': [
          this.isEdit
            ? `product/${this.form.ID}/additional-`
            : `product/additional-${this.form['Tw'].Name}-`
        ]
      }
      return params
    },
    initForm () {
      var formSource = null
      let id = parseInt(this.$route.params.id)
      if (id && id > 0) {
        let idx = this.$store.state.product.list.findIndex(o => o.ID === id)
        if (this.isTeamBuyingProduct) {
          this.oriObj = this.teamBuying.Products.find(o => o.ID == id)
          formSource = JSON.parse(JSON.stringify(this.oriObj))

          // formSource.OriginInfoIDs = (formSource.OriginInfos || []).map(o => o.ID)
          // for (let key of this.languages) {
          //   formSource[key].TagIDs = formSource[key].Tags.map(o => o.ID)
          //   formSource[key].CategoryIDs = formSource[key].Categories ? formSource[key].Categories.map(o => o.ID) : []
          //   if (!formSource[key].Discount) formSource[key].Discount = {}
          // }
          this.form = formSource
        } else if (idx >= 0) {
          this.oriObj = this.$store.state.product.list[idx]
          formSource = JSON.parse(JSON.stringify(this.oriObj))

          formSource.OriginInfoIDs = (formSource.OriginInfos || []).map(o => o.ID)
          for (let key of this.languages) {
            formSource[key].TagIDs = formSource[key].Tags.map(o => o.ID)
            formSource[key].CategoryIDs = formSource[key].Categories ? formSource[key].Categories.map(o => o.ID) : []
            if (!formSource[key].Discount) formSource[key].Discount = {}
          }
          this.form = formSource
        } else {
          console.error(`unknown product for id ${id}`)
        }
      }

      // cache
      this.cacheKey = 'cache-product-' + (this.isEdit ? this.oriObj.ID : 0)
      let cache = this.getCache()
      if (cache) {
        this.confirmLoadCache().then(result => {
          if (result !== 'loaded') return
          let cacheForm = JSON.parse(cache)

          cacheForm.OriginInfoIDs = (cacheForm.OriginInfos || []).map(o => o.ID)
          for (let key of this.languages) {
            cacheForm[key].TagIDs = cacheForm[key].Tags.map(o => o.ID)
            cacheForm[key].CategoryIDs = cacheForm[key].Categories ? cacheForm[key].Categories.map(o => o.ID) : []
            if (!cacheForm[key].Discount) cacheForm[key].Discount = {}
          }
          this.form = cacheForm
        }).catch(err => {
          console.error(err)
        })
      }
    }
  },
  created () {
    this.initForm()
  }
}
</script>

<style>
.el-tabs {
  height: 100%;
}
.el-tabs .el-tabs__content {
  height: calc(100% - 50px);
  overflow-y: auto;
}
.el-tab-pane {
  max-width: 1030px;
}
</style>
<style scoped>

.btn-translate {
  position: absolute;
  top: 26px;
  right: 110px;
}

.btn-set-url {
  position: absolute;
  top: 26px;
  right: 205px;
}
.switch-deploy {
  position: absolute !important;
  top: 30px;
  right: 300px;
}

.auto-save-hint {
  position: absolute;
  top: 33px;
  right: 424px;
  color: gray;
  font-size: 14px;
}

.url-hint {
  position: absolute;
  top: 0;
  left: 20px;
  color: gray;
  font-size: 14px;
}
</style>
